import { StyleTypesApiEnum } from '../../../api/styles/enum/style-types-api.enum';

// Page builder
import { BlockTypeModel } from '../../../Common/PageBuilder/models/block-type.model';
import { CuratorStyleFieldModel } from '../../../Common/PageBuilder/models/curator-style-field.model';
import { CuratorStyleFieldComponent } from '../../../Common/PageBuilder/components/FormFields/CuratorStyleField/curator-style-field.component';
import { ResizeDirectionEnum } from '../../../Common/Forms/components/TextareaInput/textarea-input.component';
import { StyleStateEnum } from '../../../Common/PageBuilder/enums/style-state.enum';
import { BlockTypeGroupModel } from '../../../Common/PageBuilder/models/block-type-group.model';
import { AlertMentionListBlockComponent } from '../components/AlertMentionListBlock/alert-mention-list-block.component';
import { DateDisplayElementModel } from '../../../Common/PageBuilder/models/date-display-element.model';
import { TextFieldComponent } from '../../../Common/PageBuilder/components/FormFields/TextField/text-field.component';
import { TextFieldModel, TextFieldStyle } from '../../../Common/PageBuilder/models/text-field.model';
import { CheckboxFieldComponent } from '../../../Common/PageBuilder/components/FormFields/CheckboxField/checkbox-field.component';
import { PanelFieldComponent } from '../../../Common/PageBuilder/components/FormFields/PanelField/panel-field.component';
import { CheckboxFieldModel } from '../../../Common/PageBuilder/models/checkbox-field.model';
import { PanelFieldModel } from '../../../Common/PageBuilder/models/panel-field.model';
import { TextStyleDefaultsModel } from '../../../Common/PageBuilder/models/text-style-defaults.model';
import { TextStyleFieldModel } from '../../../Common/PageBuilder/models/text-style-field.model';
import { RichTextBlockComponent } from '../../../Common/PageBuilder/components/RichTextBlock/rich-text-block.component';
import { ImageSettingsFieldComponent } from '../../../Common/PageBuilder/components/FormFields/ImageSettingsField/image-settings-field.component';
import { ImageStyleFieldComponent } from '../../../Common/PageBuilder/components/FormFields/ImageStyleField/image-style-field.component';
import { ImageSettingsFieldModel } from '../../../Common/PageBuilder/models/image-settings-field.model';
import { ImageStyleFieldModel } from '../../../Common/PageBuilder/models/image-style-field.model';

import { CheckboxOptionModel } from '../../../Common/Forms/models/checkbox-option.model';

import { MentionCustomizationFieldModel } from '../../Shared/models/mention-customization-field.model';
import { BriefingDateStyleFieldComponent } from '../../Shared/components/BriefingDateStyleField/briefing-date-style-field.component';
import { BriefingTextStyleFieldComponent } from '../../Shared/components/BriefingTextStyleField/briefing-text-style-field.component';

import { BriefingBlockTypeEnum, isMentionBlockTypes } from '../../Briefings/enums/briefing-block-type.enum';
import { BriefingDateFieldComponent } from '../../Briefings/components/BriefingDateField/briefing-date-field.component';
import { BriefingDateFieldModel } from '../../Briefings/models/briefing-date-field.model';
import { BriefingDateStyleFieldModel } from '../../Briefings/models/briefing-date-style-field.model';
import { BriefingTextDisplayElementModel } from '../../Briefings/models/briefing-text-display-element.model';
import { briefingsStyleDropdownOptions } from '../../Briefings/models/briefings-style-dropdown-options.model';

import { AlertMentionListDisplayElementModel } from './alert-mention-list-display-element.model';
import { AlertMentionCustomizationFieldComponent } from '../components/AlertMentionCustomizationField/alert-mention-customization-field.component';
import { AlertSurgeDisplayElementModel } from './alert-surge-display-element.model';
import { BriefingTitleDisplayElementModel } from '@Monitor/Briefings/models/briefing-title-display-element.model';
import { DropdownFieldComponent } from '@Common/PageBuilder/components/FormFields/DropdownField/dropdown-field.component';
import { DropdownFieldModel } from '@Common/PageBuilder/models/dropdown-field.model';
import { briefingHeadingLevelOptions } from '@Monitor/Briefings/models/briefing-heading-level.model';
import { MonitoringTitleFieldModel } from '@Monitor/Shared/models/monitoring-title-field.model';
import { BriefingHeadingLevelEnum } from '@Monitor/Briefings/enums/briefing-heading-level.enum';
import { BriefingTitleStyleFieldComponent } from '@Monitor/Shared/components/BriefingTitleStyleField/briefing-title-style-field.component';
import { BriefingImageBlockComponent } from '@Monitor/Briefings/components/BriefingImageBlock/briefing-image-block.component';
import { BriefingImageDisplayElementModel } from '@Common/PageBuilder/models/briefing-image-display-element.model';
import {
    MultiContentLibraryPanelFieldComponent
} from '@Common/PageBuilder/components/FormFields/MultiContentLibraryPanelField/multi-content-library-panel.component';
import { MultiContentLibraryFieldModel } from '@Common/PageBuilder/models/multi-content-library-field-model';
import { CuratorBlockComponent } from '@Common/PageBuilder/components/CuratorBlock/curator-block.component';
import { CuratorBlockType } from '@Common/PageBuilder/models/curator-block-type.model';
import { CuratorDisplayElement } from '@Common/PageBuilder/models/curator-display-element.model';
import { promptLanguageOptions } from '@Common/Forms/data/prompt-language-options';
import { BlockModel, LayoutBlockTypesEnum } from '@Common/PageBuilder/models/block.model';
import { LayoutBlockType, layoutBlockTypes } from '@Common/PageBuilder/models/layout-block-type.model';
import { LayoutStyleField } from '@Common/PageBuilder/models/layout-style-field.model';
import { LayoutStyleFieldComponent } from '@Common/PageBuilder/components/FormFields/LayoutStyleField/layout-style-field.component';
import { LayoutDisplayElement } from '@Common/PageBuilder/models/layout-display-element.model';
import { LayoutBlockComponent } from '@Common/PageBuilder/components/LayoutBlock/layout-block.component';
import { DropdownOptionModel } from '@Common/Forms/models/dropdown-option.model';
import { AnalysisDisplayElementModel } from '@Monitor/Briefings/models/briefing-analysis-display-element.model';
import { AnalysisField } from '@Monitor/Shared/models/analysis-field.model';
import { AnalysisFieldComponent } from '@Monitor/Briefings/components/AnalysisField/analysis-field.component';
import { BooleanRadioFieldModel } from '@Common/PageBuilder/models/boolean-radio-field.model';
import { BooleanRadioFieldComponent } from '@Common/PageBuilder/components/FormFields/BooleanRadioField/boolean-radio-field.component';
import { MentionSearchService } from '@Monitor/Core/services/mention-search.service';
import { monitoringFiltersEnum } from '@Monitor/Shared/enums/monitoring-filters.enum';
import { MonitoringSeriesTypeEnum } from '@Monitor/Shared/enums/monitoring-series-type.enum';
import { AnalysisBlockMonitoringSourcePickerFieldComponent } from
    '@Monitor/Shared/components/MonitoringSourcePickerField/analysis-block-monitoring-source-picker-field.component';
import { MonitoringSourcePickerFieldModel } from '@Monitor/Shared/models/monitoring-source-picker-field.model';
import { NumberFieldModel } from '@Common/PageBuilder/models/number-field.model';
import { BriefingStyleStateEnum } from '@Common/MonitorShared/enum/briefing-style-state.enum';
import { NumberFieldComponent } from '@Common/PageBuilder/components/FormFields/NumberField/number-field.component';
import { BlockDisplayTypeEnum } from '@Common/PageBuilder/enums/block-display-type.enum';
import { BriefingSortByFieldComponent } from '@Monitor/Briefings/components/BriefingSortByField/briefing-sort-by-field.component';
import { DynamicMentionListBlockComponent } from '@Monitor/Briefings/components/DynamicMentionListBlock/dynamic-mention-list-block.component';
import { BriefingSortByFieldModel } from '@Monitor/Briefings/models/briefing-sort-by.field.model';
import { DynamicMentionListDisplayElementModel } from '@Monitor/Briefings/models/dynamic-mention-list-display-element.model';
import { MentionCustomizationFieldComponent } from '@Monitor/Shared/components/MentionCustomizationField/mention-customization-field.component';
import { AiAnalysisTypes } from '@Common/Mentions/enums/ai-analysis-types.enum';
import { AutomaticAdditionalSettingsField } from '@Monitor/Alerts/models/automatic-additional-settings-field.model';
import { ChartFieldModel } from '@Common/PageBuilder/models/chart-field.model';
import { ChartFieldComponent } from '@Common/PageBuilder/components/FormFields/ChartField/chart-field.component';
import { BriefingChartDisplayElementModel } from '@Common/PageBuilder/models/briefing-chart-display-element.model';
import { BriefingChartBlockComponent } from '@Monitor/Briefings/components/BriefingChartBlock/briefing-chart-block.component';
import { BriefingChartDimensionsFieldModel } from '@Common/PageBuilder/models/briefing-chart-dimensions-field.model';
import {
    BriefingChartDimensionsFieldComponent
} from '@Common/PageBuilder/components/FormFields/BriefingChartDimensionsField/briefing-chart-dimensions-field.component';
import { BriefingChartSettingsFieldComponent } from '@Common/PageBuilder/components/FormFields/ImageSettingsField/briefing-chart-settings-field.component';
import { DividerStyleFieldModel } from '@Common/PageBuilder/models/divider-style-field.model';
import { DividerStyleDefaultsModel } from '@Common/PageBuilder/models/divider-style-defaults.model';
import { PaddingModel } from '@Common/PageBuilder/models/padding.model';
import { DividerStyleFieldComponent } from '@Common/PageBuilder/components/FormFields/DividerField/divider-style-field.component';
import { DividerDisplayElementModel } from '@Common/PageBuilder/models/divider-display-element.model';


// Also an Automatic block, but specifically for Recent Alert's
export const alertMentionListBlockType: BlockTypeModel = new BlockTypeModel(
    BriefingBlockTypeEnum.ALERT_MENTIONS,
    'Briefings.blockType.mentionList.dynamic',
    'fa-regular fa-duotone fa-list-ul',
    null,
    AlertMentionListDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            'dynamicMentionListPanel',
            'Briefings.blockType.mentionList.dynamic',
            '',
            [
                new TextFieldModel(
                    TextFieldComponent,
                    'title',
                    'Briefings.mentionList.form.sectionHeading',
                    null,
                    false,
                    256,
                    '',
                    false
                ),
            ]
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefing.styles.mentionStylesSettings',
            '',
            [
                new MentionCustomizationFieldModel(
                    AlertMentionCustomizationFieldComponent,
                    'styles',
                    'MentionStyleField.heading',
                    '',
                    false
                )
            ]
        )
    ],
    AlertMentionListBlockComponent
);

export const alertSurgeBlockType: BlockTypeModel = new BlockTypeModel(
    BriefingBlockTypeEnum.SURGE_ALERT,
    'Briefings.blockType.alertSurge.header',
    '',
    null,
    AlertSurgeDisplayElementModel,
    [],
    null,
    null,
    null,
    false,
    false
);

export const alertDateBlockType: BlockTypeModel = new BlockTypeModel(
    BriefingBlockTypeEnum.DATE,
    'Briefings.blockType.date',
    'fa-duotone fa-regular fa-calendar-range',
    null,
    DateDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefings.blockType.date',
            '',
            [
                new BriefingDateFieldModel(
                    BriefingDateFieldComponent,
                    'date',
                    'Briefings.formField.dateLabel',
                    null
                )
            ]
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefing.styles.dateStylesSettings',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new BriefingDateStyleFieldModel(
                    BriefingDateStyleFieldComponent,
                    'styles',
                    'DateStyleField.dateLine',
                    ''
                )
            ]
        )
    ]
);

export const titleBlockType = new BlockTypeModel(
    BriefingBlockTypeEnum.TITLE,
    'PageBuilder.blockType.title',
    'agpr-i-headline',
    null,
    BriefingTitleDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.blockType.title',
            '',
            [
                new BooleanRadioFieldModel(
                    BooleanRadioFieldComponent,
                    'automaticallyGenerated',
                    'PageBuilder.automaticallyGeneratedContent.ai',
                    'PageBuilder.automaticallyGeneratedContent.manual',
                    (displayElement) => {
                        return displayElement?.canAutomaticallyGenerated;
                    }
                ),
                new TextFieldModel(
                    TextFieldComponent,
                    'text',
                    'PageBuilder.formField.titleLabel',
                    null,
                    false,
                    128,
                    'Briefing.title.settings.helperText',
                    null,
                    null,
                    null,
                    'PageBuilder.automaticallyGeneratedContent.placeholder'
                ),
                new DropdownFieldModel(
                    DropdownFieldComponent,
                    'headingLevel',
                    'Briefings.formField.title.headlingLevel',
                    null,
                    [
                        ...briefingHeadingLevelOptions
                    ]
                )
            ]
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefing.styles.titleStylesSettings',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new MonitoringTitleFieldModel(
                    'styles',
                    false,
                    new TextStyleDefaultsModel(
                        '24px',
                        '#5e6473',
                        true
                    ),
                    `Briefings.title.headingLevel.style.${BriefingHeadingLevelEnum.HEADING_1}`,
                    false,
                    true,
                    true,
                    StyleTypesApiEnum.TITLE,
                    BriefingTitleStyleFieldComponent,
                    null,
                    true,
                    true,
                    briefingsStyleDropdownOptions
                )
            ],
        )
    ]
);

export const textBlockType = new BlockTypeModel(
    BriefingBlockTypeEnum.TEXT,
    'PageBuilder.blockType.text',
    'fa-solid fa-align-left',
    null,
    BriefingTextDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefing.styles.textStylesSettings',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new TextStyleFieldModel(
                    'styles',
                    true,
                    new TextStyleDefaultsModel(
                        '14px',
                        '#292929',
                        false
                    ),
                    'Briefing.textStyle.text.label',
                    true,
                    true,
                    true,
                    StyleTypesApiEnum.TEXT,
                    BriefingTextStyleFieldComponent,
                    null,
                    true,
                    true,
                    briefingsStyleDropdownOptions
                )
            ]
        )
    ],
    RichTextBlockComponent
);

export const imageBlockType = new BlockTypeModel(
    BriefingBlockTypeEnum.IMAGE,
    'PageBuilder.blockType.image',
    'fa-regular fa-duotone fa-image',
    null,
    BriefingImageDisplayElementModel,
    [
        new MultiContentLibraryFieldModel(
            MultiContentLibraryPanelFieldComponent,
            'images',
            'Briefings.fields.image.imageUpload',
            {
                description: 'PageBuilder.formField.uploadDescription',
                maxFiles: 4,
                placeholder: 'Mention.workbench.image.placeholder',
            }
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefings.fields.image.imageSettings',
            '',
            [
                new ImageSettingsFieldModel(
                    ImageSettingsFieldComponent,
                    'imageProperties',
                    'PageBuilder.formField.uploadLabel',
                    'PageBuilder.formField.uploadDescription',
                    true, // enableTooltip
                    false // enableAltText
                ),
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new ImageStyleFieldModel(
                    'styles',
                    true,
                    new TextStyleDefaultsModel(
                        '24px',
                        '#5e6473',
                        true
                    ),
                    'Briefing.imageTextStyle.image.label',
                    true,
                    true,
                    true,
                    StyleTypesApiEnum.IMAGE,
                    ImageStyleFieldComponent,
                    '',
                    briefingsStyleDropdownOptions,
                    null,
                    false
                )
            ]
        )
    ],
    BriefingImageBlockComponent
);
const defaultAlertCoverageCuratorDatasourceField = new MonitoringSourcePickerFieldModel(
    AnalysisBlockMonitoringSourcePickerFieldComponent,
    'backendDataSource',
    '',
    '',
    {
        dataSourceLabel: 'Monitoring.sourcePickerField.coverageSource',
        dateRangeLabel: 'Monitoring.sourcePickerField.dateRange',
        mentionCountLocalizationLabel: 'Monitoring.sourcePickerField.briefingsResultFeedbackMessage',
        maxNumberOfMentions: 1000,
        warningNumberOfMentions: 400,
        dataSourceNullErrorMessage: 'Monitoring.sourcePickerField.dataSourceRequiredMessage',
        mentionCountLimitExceededLocalizationTitle: 'Monitoring.bulkActionDialog.sourcePickerField.collectionMayBeReduced',
        mentionCountLimitExceededLocalizationLabel: 'Monitoring.bulkActionDialog.sourcePickerField.pleaseRefineSource',
        dataSourceOptions: [
            new DropdownOptionModel('Monitoring.sourcePickerField.surgeSource', MonitoringSeriesTypeEnum.coverageSurge),
            new DropdownOptionModel('Reports.series.type.topic', MonitoringSeriesTypeEnum.topic),
            new DropdownOptionModel('Reports.series.type.subscription', MonitoringSeriesTypeEnum.subscription),
            new DropdownOptionModel('Reports.series.type.socialTopic', MonitoringSeriesTypeEnum.socialTopic),
            new DropdownOptionModel('Reports.series.type.theme', MonitoringSeriesTypeEnum.theme)
        ],
        showResultsFeedback: false,
        showResultsFeedbackAnalysis: false,
        showLoadingFeedback: false,
        showTooManyMentionsError: true,
        showFilters: true,
        orderedAccountFilters: MentionSearchService.defaultOrderedAccountFilters.concat(monitoringFiltersEnum.regions)
    }
);
export const surgeAlertAiCuratorBlockType = new CuratorBlockType(
    BriefingBlockTypeEnum.COVERAGE_CURATOR,
    'PageBuilder.blockType.curator',
    'fa-kit-duotone fa-agpr-ai-coverage',
    null,
    CuratorDisplayElement,
    [
        new TextFieldModel(
            TextFieldComponent,
            'bulkAnalysisMessage.adHocCustomPrompt',
            'PageBuilder.blockType.curation.settings.CurationInstructions',
            null,
            true,
            255,
            'PageBuilder.blockType.curation.settings.CurationInstructions.placeholder',
            null,
            null,
            null,
            null,
            (displayElement: CuratorDisplayElement) => {
                return displayElement?.bulkAnalysisMessage?.aiAnalysisType === AiAnalysisTypes.COLLECTION_CUSTOM;
            },
            {indent: 30} as TextFieldStyle,
            ResizeDirectionEnum.vertical,
            true,
            true
        ),
        defaultAlertCoverageCuratorDatasourceField,
        new TextFieldModel(
            TextFieldComponent,
            'bulkAnalysisMessage.focus',
            'PageBuilder.blockType.curation.settings.analysisFocus',
            null,
            false,
            255,
            'PageBuilder.blockType.curation.settings.analysisFocus.placeholder',
            null,
            'PageBuilder.blockType.curation.settings.analysisFocus.tooltip'
        ),
        new DropdownFieldModel(
            DropdownFieldComponent,
            'bulkAnalysisMessage.selectedLanguageTag',
            'Common.dialog.aiHelper.language',
            null,
            promptLanguageOptions,
            'Common.dialog.aiHelper.languageTooltip',
            null
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.blockType.curator.settings',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new CuratorStyleFieldModel(
                    CuratorStyleFieldComponent,
                    (x: CuratorStyleFieldComponent) => {
                        return [
                            { label: 'PageBuilder.formField.styles.defaultAgilityStyle', value: StyleStateEnum.DEFAULT },
                            { label: 'PageBuilder.formField.styles.custom', value: StyleStateEnum.CUSTOM }
                        ];
                    }
                )
            ]
        )
    ],
    CuratorBlockComponent,
    false
);
export const alertAnalysisBlockType = new BlockTypeModel(
    BriefingBlockTypeEnum.ANALYSIS,
    'PageBuilder.blockType.analysis',
    'fa-kit-duotone fa-agpr-insights',
    null,
    AnalysisDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefings.analysis.header',
            '',
            [
                new BooleanRadioFieldModel(
                    BooleanRadioFieldComponent,
                    'automaticallyGenerated',
                    'PageBuilder.automaticallyGeneratedContent.ai',
                    'PageBuilder.automaticallyGeneratedContent.manual',
                    (displayElement) => {
                        return displayElement?.canAutomaticallyGenerated;
                    }
                ),
                new MonitoringSourcePickerFieldModel(
                    AnalysisBlockMonitoringSourcePickerFieldComponent,
                    'backendDataSource',
                    '',
                    '',
                    {
                        dataSourceLabel: 'Monitoring.sourcePickerField.coverageSource',
                        maxNumberOfMentions: 10000,
                        warningNumberOfMentions: 400,
                        dateRangeLabel: 'Monitoring.sourcePickerField.dateRange',
                        mentionCountLocalizationLabel: 'Monitoring.sourcePickerField.analysisResultFeedbackMessage',
                        dataSourceNullErrorMessage: 'Monitoring.sourcePickerField.dataSourceRequiredMessage',
                        mentionCountLimitExceededLocalizationTitle: 'Monitoring.bulkActionDialog.sourcePickerField.collectionMayBeReduced',
                        mentionCountLimitExceededLocalizationLabel: 'Monitoring.bulkActionDialog.sourcePickerField.pleaseRefineSource',
                        showTooManyMentionsError: true,
                        showResultsFeedbackAnalysis: false,
                        showResultsFeedback: false,
                        showLoadingFeedback: false,
                        dataSourceOptions: [
                            new DropdownOptionModel('Monitoring.sourcePickerField.surgeSource', MonitoringSeriesTypeEnum.coverageSurge),
                            new DropdownOptionModel('Reports.series.type.topic', MonitoringSeriesTypeEnum.topic),
                            new DropdownOptionModel('Reports.series.type.subscription', MonitoringSeriesTypeEnum.subscription),
                            new DropdownOptionModel('Reports.series.type.socialTopic', MonitoringSeriesTypeEnum.socialTopic),
                            new DropdownOptionModel('Reports.series.type.theme', MonitoringSeriesTypeEnum.theme)
                        ],
                        showFilters: true,
                        orderedAccountFilters: MentionSearchService.defaultOrderedAccountFilters.concat(monitoringFiltersEnum.regions)
                    }
                ),
                new AnalysisField(
                    AnalysisFieldComponent,
                    'Briefings.blockType.autoGeninsights.label',
                    'analysisField',
                    [
                        new DropdownOptionModel(`Mention.workbench.insights.system.${AiAnalysisTypes.COVERAGE_SURGE_INSIGHT}`,
                            AiAnalysisTypes.COVERAGE_SURGE_INSIGHT),
                        new DropdownOptionModel(`Mention.workbench.insights.system.${AiAnalysisTypes.EXECUTIVE_SUMMARY}`,
                            AiAnalysisTypes.EXECUTIVE_SUMMARY),
                        new DropdownOptionModel(`Mention.workbench.insights.system.${AiAnalysisTypes.KEY_TAKEAWAYS}`,
                            AiAnalysisTypes.KEY_TAKEAWAYS),
                        new DropdownOptionModel(`Mention.workbench.insights.system.${AiAnalysisTypes.BRAND_IMPACT}`,
                            AiAnalysisTypes.BRAND_IMPACT),
                        new DropdownOptionModel(`Mention.workbench.insights.system.${AiAnalysisTypes.SENTIMENT_OPINION}`,
                            AiAnalysisTypes.SENTIMENT_OPINION),
                        new DropdownOptionModel(`Mention.workbench.insights.system.${AiAnalysisTypes.TOP_NARRATIVES}`,
                            AiAnalysisTypes.TOP_NARRATIVES),
                        new DropdownOptionModel(`Mention.workbench.insights.system.${AiAnalysisTypes.CUSTOM}`,
                            AiAnalysisTypes.CUSTOM),
                    ]
                )
            ]
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefing.styles.analysisStylesSettings',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new TextStyleFieldModel(
                    'styles',
                    true,
                    new TextStyleDefaultsModel(
                        '14px',
                        '#292929',
                        false
                    ),
                    'Briefing.textStyle.analysis.label',
                    true,
                    true,
                    true,
                    StyleTypesApiEnum.ANALYSIS,
                    BriefingTextStyleFieldComponent,
                    null,
                    true,
                    true,
                    briefingsStyleDropdownOptions,

                )
            ]
        )
    ],
    RichTextBlockComponent,
    null,
    'Briefing.blocks.reachLimit.analysis'
);
export const alertDynamicMentionListBlockType: BlockTypeModel = new BlockTypeModel(
    BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST,
    'Briefings.blockType.mentionList.dynamic',
    'fa-regular fa-duotone fa-list-ul',
    null,
    DynamicMentionListDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            'dynamicMentionListPanel',
            'Briefings.blockType.mentionList.dynamic',
            '',
            [
                new TextFieldModel(
                    TextFieldComponent,
                    'title',
                    'Briefings.mentionList.form.sectionHeading',
                    null,
                    false,
                    256,
                    '',
                    false,
                    null,
                    null,
                    'PageBuilder.automaticallyGeneratedContent.placeholder'
                ),
                new NumberFieldModel(
                    NumberFieldComponent,
                    'pageSize',
                    'Briefings.dynamicMentionsList.form.numberOfMentions',
                    null,
                    'Briefings.dynamicMentionsList.form.selectPageSize.placeholder',
                    1000,
                    1,
                    'Briefings.dynamicMentionsList.form.numberOfMentionsTooltip',
                    'left'
                ),
                new BriefingSortByFieldModel(
                    BriefingSortByFieldComponent,
                    'backendDataSource.filterSearchCriteria',
                    'Briefings.mentionList.form.sortBy',
                    true
                ),
                new NumberFieldModel(
                    NumberFieldComponent,
                    'mentionPreviewCount',
                    'Briefings.mentionList.form.previewMentionCount',
                    null,
                    'Briefings.mentionList.form.previewMentionCount.placeholder',
                    100,
                    null,
                    'Briefings.mentionList.form.previewMentionCount',
                    'left',
                    (block: BlockModel) => {
                        return false;
                    }
                )
            ]
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefing.styles.mentionStylesSettings',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new MentionCustomizationFieldModel(
                    MentionCustomizationFieldComponent,
                    'styles',
                    'MentionStyleField.heading',
                    '',
                    undefined,
                    (x: MentionCustomizationFieldComponent) => {
                        return briefingsStyleDropdownOptions;
                    }
                )
            ]
        )
    ],
    DynamicMentionListBlockComponent
);



export const alertChartBlockType = new BlockTypeModel(
    BriefingBlockTypeEnum.CHART,
    'PageBuilder.blockType.chart',
    'fa-pie-chart fa-duotone fa-regular',
    null,
    BriefingChartDisplayElementModel,
    [
        new ChartFieldModel(
            ChartFieldComponent,
            'chart',
            [
                new PanelFieldModel(
                    PanelFieldComponent,
                    '',
                    'PageBuilder.blockType.chart.settings',
                    '',
                    [
                        new BriefingChartDimensionsFieldModel(
                            BriefingChartDimensionsFieldComponent,
                            'chart'
                        ),
                        new ImageSettingsFieldModel(
                            BriefingChartSettingsFieldComponent,
                            'settings',
                            '',
                            '',
                            true,
                            true,
                            false,
                            false
                        ),
                        new CheckboxFieldModel(
                            CheckboxFieldComponent,
                            'isBoundToGlobalStyles',
                            '',
                            '',
                            new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                            true
                        ),
                        new ImageStyleFieldModel(
                            'styles',
                            true,
                            new TextStyleDefaultsModel(
                                '24px',
                                '#5e6473',
                                true
                            ),
                            'Briefing.chartStyle.chart.label',
                            true,
                            true,
                            true,
                            StyleTypesApiEnum.CHART,
                            ImageStyleFieldComponent,
                            '',
                            briefingsStyleDropdownOptions
                        )
                    ]
                )
            ]
        )
    ],
    BriefingChartBlockComponent,
    false,
    null,
    true,
    false
);

export const alertDividerBlockType = new BlockTypeModel(
    BriefingBlockTypeEnum.DIVIDER,
    'PageBuilder.blockType.divider',
    'fa-kit-duotone fa-agpr-divider',
    null,
    DividerDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.blockType.divider',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('PageBuilder.formField.updateAllBlocksOfType', ''),
                    true
                ),
                new DividerStyleFieldModel(
                    'styles',
                    true,
                    new DividerStyleDefaultsModel(
                        2,
                        '#C7C7C7',
                        '#FFFFFF',
                        new PaddingModel(0, true, 20, 0, 20, 0)
                    ),
                    'PageBuilder.formField.dividerLabel',
                    true,
                    StyleTypesApiEnum.DIVIDER,
                    DividerStyleFieldComponent,
                    undefined,
                    briefingsStyleDropdownOptions
                )
            ]
        )
    ]
);

const alertLayoutStyleOptions = () => [
    { label: 'PageBuilder.formField.styles.defaultAgilityStyle', value: StyleStateEnum.DEFAULT },
    { label: 'PageBuilder.formField.styles.custom', value: StyleStateEnum.CUSTOM }
];

export const alertOneColumnLayoutBlockType = new LayoutBlockType(
    BriefingBlockTypeEnum.ONE_COLUMN_LAYOUT,
    'PageBuilder.blockType.layout.oneColumn',
    'fa-regular fa-duotone fa-objects-column',
    null,
    LayoutDisplayElement,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.formField.panelHeader.oneColumnLayout',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new LayoutStyleField(LayoutStyleFieldComponent, 1, alertLayoutStyleOptions)
            ]
        )
    ],
    LayoutBlockComponent,
    false,
    (blockType: BlockTypeModel) => {
        return blockType
            ? (layoutBlockTypes.includes(blockType.key as LayoutBlockTypesEnum) || blockType.key === BriefingBlockTypeEnum.COVERAGE_CURATOR)
            : false;
    }
);

export const alertTwoColumnLayoutBlockType = new LayoutBlockType(
    BriefingBlockTypeEnum.TWO_COLUMN_LAYOUT,
    'PageBuilder.blockType.layout.twoColumn',
    'fa-regular fa-duotone fa-objects-column',
    null,
    LayoutDisplayElement,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.formField.panelHeader.twoColumnlayout',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new LayoutStyleField(LayoutStyleFieldComponent, 2, alertLayoutStyleOptions)
            ]
        )
    ],
    LayoutBlockComponent,
    false,
    (blockType: BlockTypeModel) => {
        const isLayoutBlock = blockType ? layoutBlockTypes.includes(blockType.key as LayoutBlockTypesEnum) : false;
        const isMentionBlock = blockType ? isMentionBlockTypes(blockType) : false;
        const isCuratorBlock = blockType ? blockType.key === BriefingBlockTypeEnum.COVERAGE_CURATOR : false;
        return isLayoutBlock || isMentionBlock || isCuratorBlock;
    }
);

export const alertThreeColumnLayoutBlockType = new LayoutBlockType(
    BriefingBlockTypeEnum.THREE_COLUMN_LAYOUT,
    'PageBuilder.blockType.layout.threeColumn',
    'fa-regular fa-duotone fa-objects-column',
    null,
    LayoutDisplayElement,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.formField.panelHeader.threeColumnlayout',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new LayoutStyleField(LayoutStyleFieldComponent, 3, alertLayoutStyleOptions)
            ]
        )
    ],
    LayoutBlockComponent,
    false,
    (blockType: BlockTypeModel) => {
        const isLayoutBlock = blockType ? layoutBlockTypes.includes(blockType.key as LayoutBlockTypesEnum) : false;
        const isMentionBlock = blockType ? isMentionBlockTypes(blockType) : false;
        const isCuratorBlock = blockType ? blockType.key === BriefingBlockTypeEnum.COVERAGE_CURATOR : false;
        return isLayoutBlock || isMentionBlock || isCuratorBlock;
    }
);

export const alertLayoutBlockTypes: LayoutBlockType[] = [
    alertOneColumnLayoutBlockType,
    alertTwoColumnLayoutBlockType,
    alertThreeColumnLayoutBlockType
];

export const alertBlockTypeEnumToBlockTypeMap: Map<BriefingBlockTypeEnum, BlockTypeModel> = new Map(
    [
        [BriefingBlockTypeEnum.TITLE, titleBlockType],
        [BriefingBlockTypeEnum.TEXT, textBlockType],
        [BriefingBlockTypeEnum.IMAGE, imageBlockType],
        [BriefingBlockTypeEnum.DATE, alertDateBlockType],
        [BriefingBlockTypeEnum.ALERT_MENTIONS, alertMentionListBlockType],
        [BriefingBlockTypeEnum.SURGE_ALERT, alertSurgeBlockType],
        [BriefingBlockTypeEnum.COVERAGE_CURATOR, surgeAlertAiCuratorBlockType],
        [BriefingBlockTypeEnum.ANALYSIS, alertAnalysisBlockType],
        [BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST, alertDynamicMentionListBlockType],
        [BriefingBlockTypeEnum.CHART, alertChartBlockType],
        [BriefingBlockTypeEnum.DIVIDER, alertDividerBlockType],
        [BriefingBlockTypeEnum.ONE_COLUMN_LAYOUT, alertOneColumnLayoutBlockType],
        [BriefingBlockTypeEnum.TWO_COLUMN_LAYOUT, alertTwoColumnLayoutBlockType],
        [BriefingBlockTypeEnum.THREE_COLUMN_LAYOUT, alertThreeColumnLayoutBlockType],
    ]
);

const alertsDefaultBlockTypes: BlockTypeModel[] = [
    titleBlockType,
    textBlockType,
    imageBlockType,
    alertDateBlockType,
    alertChartBlockType,
    alertAnalysisBlockType,
    alertDividerBlockType,
    surgeAlertAiCuratorBlockType
];

export const alertsBlockTypes: BlockTypeModel[] = [
    ...alertsDefaultBlockTypes,
    alertMentionListBlockType
];

// The "alertMentionListBlockType" can't be added or removed, it's always just there, so we ignore it from the groups
export const alertsBlockTypeGroups: BlockTypeGroupModel[] = [
    {
        blockTypes: alertsDefaultBlockTypes
    }
];

const recentAlertsDefaultBlockTypes: BlockTypeModel[] = [
    titleBlockType,
    textBlockType,
    imageBlockType,
    alertDateBlockType,
];

export const recentAlertsBlockTypes: BlockTypeModel[] = [
    ...recentAlertsDefaultBlockTypes,
    alertMentionListBlockType
];

export const recentAlertsBlockTypeGroups: BlockTypeGroupModel[] = [
    {
        blockTypes: recentAlertsDefaultBlockTypes
    }
];
